import EntitledComponent from './EntitledComponent';

export default EntitledComponent;
